import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react';
import { FaUsersRectangle } from 'react-icons/fa6';
import { IoCartOutline } from 'react-icons/io5';
import {
	MdOutlineSpaceDashboard,
	MdOutlineCollectionsBookmark,
	MdOutlineCalendarMonth,
	MdOutlineDocumentScanner,
	MdOutlineGroups3,
	MdOutlineDatasetLinked,
} from 'react-icons/md';
import { GrSecure } from 'react-icons/gr';
import { RiMoneyEuroCircleLine } from 'react-icons/ri';
import { DataSidebarInterface } from '@/interfaces';
import { PATHS } from '@/routes';

// Ejemplo de datos:
export const dataSidebar: DataSidebarInterface = {
	user: {
		name: 'Jose Dominguez',
		email: 'josedominguez@gmail.com',
		avatar: '/avatars/shadcn.jpg',
	},
	teams: [
		{
			name: 'Acme Inc',
			logo: GalleryVerticalEnd,
			plan: 'Enterprise',
		},
		{
			name: 'Acme Corp.',
			logo: AudioWaveform,
			plan: 'Startup',
		},
		{
			name: 'Evil Corp.',
			logo: Command,
			plan: 'Free',
		},
	],
	navClient: [
		{
			title: 'Clientes y Proveedores',
			url: PATHS.CLIENT_ONLY,
			icon: FaUsersRectangle,
			isActive: true,
			items: [
				{ title: 'Clientes', url: PATHS.CLIENT, requiredPermissions: 'clients.read' },
				{
					title: 'Proveedores',
					url: PATHS.SUPPLIER,
					requiredPermissions: 'suppliers.read',
				},
				{
					title: 'Subcontratas',
					url: PATHS.SUBCONTRACT,
					requiredPermissions: 'subcontractors.read',
				},
			],
		},
		{
			title: 'Productos y Servicios',
			url: PATHS.PRODUCTS_SERVICES_ONLY,
			icon: IoCartOutline,
			isActive: true,
			items: [
				{
					title: 'Desfibriladores',
					url: PATHS.DEFIBRILLATOR,
					requiredPermissions: 'defibrillators.read',
				},
				{ title: 'Productos', url: PATHS.PRODUCT, requiredPermissions: 'products.read' },
				{ title: 'Kits', url: PATHS.KIT, requiredPermissions: 'kits.read' },
			],
		},
		{
			title: 'Formaciones',
			url: PATHS.FORMATIONS_ONLY,
			icon: MdOutlineCollectionsBookmark,
			isActive: true,
			items: [
				{ title: 'Formadores', url: PATHS.TRAINER, requiredPermissions: 'trainers.read' },
				{
					title: 'Tipos de Formaciones',
					url: PATHS.TYPES_FORMATION,
					requiredPermissions: 'formation-types.read',
				},
				{
					title: 'Formaciones',
					url: PATHS.FORMATION,
					requiredPermissions: 'formations.read',
				},
			],
		},
		{
			title: 'Contabilidad',
			url: PATHS.ACCOUNTING_ONLY,
			icon: RiMoneyEuroCircleLine,
			isActive: true,
			items: [
				{ title: 'Presupuestos', url: PATHS.BUDGET, requiredPermissions: 'budgets.read' },
				{ title: 'Facturas', url: PATHS.INVOICE, requiredPermissions: 'bills.read' },
				{ title: 'Gastos', url: PATHS.BILL, requiredPermissions: 'bills.read' },
				{
					title: 'Gastos de Formadores',
					url: PATHS.BILL_TRAINER,
					requiredPermissions: 'bills-trainer.read',
				},
			],
		},
	],
	navOrganization: [
		{
			title: 'Agenda',
			url: PATHS.NOTEBOOK_ONLY,
			icon: MdOutlineCalendarMonth,
			isActive: true,
			items: [
				{ title: 'Calendario', url: PATHS.NOTEBOOK, requiredPermissions: 'calendar.read' },
			],
		},
	],
	dashboard: [
		{
			title: 'Resumenes',
			url: PATHS.DASHBOARD,
			icon: MdOutlineSpaceDashboard,
			isActive: true,
			items: [
				{
					title: 'Productos',
					url: PATHS.DASHBOARD_PRODUCT,
					requiredPermissions: 'dashboard.read',
				},
				{
					title: 'Formaciones',
					url: PATHS.DASHBOARD_FORMATION,
					requiredPermissions: 'dashboard.read',
				},
				{
					title: 'Facturación por cliente',
					url: PATHS.DASHBOARD_CLIENT_BILLING,
					requiredPermissions: 'dashboard.read',
				},
				{
					title: 'Gastos proveedores',
					url: PATHS.DASHBOARD_SUPPLIER_BILLING,
					requiredPermissions: 'dashboard.read',
				},
				{
					title: 'Gastos formadores',
					url: PATHS.DASHBOARD_TRAINER_RESUME,
					requiredPermissions: 'dashboard.read',
				},
				{
					title: 'Facturación por empresa',
					url: PATHS.DASHBOARD_COMPANY_BILLING,
					requiredPermissions: 'dashboard.read',
				},
			],
		},
	],
	searches: [
		{
			title: 'Búsquedas',
			url: PATHS.SEARCHES_ONLY,
			icon: MdOutlineDatasetLinked,
			isActive: true,
			items: [
				{
					title: 'Búsqueda de alumnos',
					url: PATHS.SEARCHES_STUDENTS,
					requiredPermissions: 'search.students',
				},
			],
		},
	],
	configurations: [
		{
			title: 'Gestión de Sociedades',
			url: PATHS.SETTINGS_COMPANY_MANAGMENT,
			icon: MdOutlineGroups3,
			isActive: true,
			items: [
				{
					title: 'Datos de sociedades',
					url: PATHS.SETTINGS_COMPANY_MANAGMENT_COMPANY_DATA,
					requiredPermissions: 'societies.read',
				},
				{
					title: 'Sociedades bonificadoras',
					url: PATHS.SETTINGS_COMPANY_MANAGMENT_BONUS_COMPANY,
					requiredPermissions: 'societies.bonus',
				},
			],
		},
		{
			title: 'Usuarios y Permisos',
			url: PATHS.SETTINGS_USER_ROLE,
			icon: GrSecure,
			isActive: true,
			items: [
				{
					title: 'Permisos de usuarios',
					url: PATHS.SETTINGS_USER_ROLE_USER,
					requiredPermissions: 'users.read',
				},
			],
		},
		{
			title: 'Datos generales',
			url: PATHS.SETTINGS_GENERAL_DATA,
			icon: MdOutlineDocumentScanner,
			isActive: true,
			items: [
				{
					title: 'Textos y contadores',
					url: PATHS.SETTINGS_LEGAL_DATA_LOPD,
					requiredPermissions: 'legal-data.read',
				},
				{
					title: 'Desplegables',
					url: PATHS.SEETINGS_GENERAL_DATA_FOLDABLE_BRAND_DEFIBRILLATOR,
					requiredPermissions: 'foldable.brands',
				},
			],
		},
	],
};
